<template>
  <model-form
    v-bind="$attrs"
    ref="modelForm"
    :model="rolePermission"
    submodel
    modal-type="modal"
    :read-only="rolePermission.restrictableModels.length === 0"
    @change="$emit('change')"
  >
    <template #title>
      <div
        class="col"
        style="max-width: 310px;"
      >
        {{ rolePermission.category }}: {{ rolePermission.label }}
      </div>
      <div class="col-auto">
        <q-btn
          class="q-ml-sm"
          icon="delete"
          color="negative"
          flat
          dense
          :ripple="false"
          @click="removePermissionAction(rolePermission.action)"
        >
          <q-tooltip>Remove</q-tooltip>
        </q-btn>
      </div>
    </template>
    <div class="text-body2">
      <!-- Permissions descriptions come from HTML templates. -->
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="rolePermission.description" />
    </div>
    <div
      v-if="rolePermission.permitsEmployeeUsers && rolePermission.permitsAdminUsers"
      class="q-mt-sm text-grey-8"
    >
      Permits users with either Employee or Admin access level.
    </div>
    <div
      v-else-if="!rolePermission.permitsEmployeeUsers && rolePermission.permitsAdminUsers"
      class="q-mt-sm text-grey-8"
    >
      Only permits users with Admin access level.
    </div>
    <div
      v-if="rolePermission.restrictableModels.length > 0 && $isPermitted($permissions.Security.ManageCircuitRoles)"
      class="row q-mt-md"
    >
      <div class="col">
        <div class="text-subtitle2 text-grey-8 text-center">
          Record Restrictions
        </div>
        <q-tabs
          v-if="rolePermission.restrictableModels.length > 1"
          v-model="tab"
        >
          <q-tab
            v-for="modelClass in rolePermission.restrictableModels"
            :key="modelClass.name"
            :name="modelClass.name"
          >
            <span>
              {{ modelClass.humanTypeName }} <q-chip dense>{{ restrictedRecordCountByModelName[modelClass.name] || 0 }}</q-chip>
            </span>
          </q-tab>
        </q-tabs>
        <q-tab-panels v-model="tab">
          <q-tab-panel
            v-for="modelClass in rolePermission.restrictableModels"
            :key="modelClass.name"
            :name="modelClass.name"
          >
            <record-restriction-fields
              :role-permission="rolePermission"
              :model-class="modelClass"
            />
          </q-tab-panel>
        </q-tab-panels>
      </div>
    </div>
    <div
      v-else-if="rolePermission.restrictableModels.length > 0"
      class="row q-mt-sm"
    >
      <div class="col text-grey-8">
        You do not have permission to configure record restrictions.
      </div>
    </div>
    <div
      v-else
      class="row q-mt-sm"
    >
      <div
        v-if="rolePermission.isRemote"
        class="col text-grey-8"
      >
        This permission does not support record restrictions.
      </div>
      <div
        v-else
        class="col text-primary"
      >
        Please save the Role before adding record restrictions.
      </div>
    </div>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import RecordRestrictionFields from 'src/modules/admin/role-permission/RecordRestrictionFields'

export default {
  name: 'RolePermissionForm',
  components: {
    ModelForm,
    RecordRestrictionFields
  },
  emits: ['change', 'remove'],
  data () {
    return {
      tab: null
    }
  },
  computed: {
    restrictedRecordCountByModelName () {
      return this.rolePermission.restrictedRecordCountByModelName
    }
  },
  watch: {
    'rolePermission.restrictableModels': {
      handler () {
        this.tab = this.rolePermission.restrictableModels[0]?.name
      },
      immediate: true
    }
  },
  models: {
    rolePermission: {
      id: true,
      restrictsRecords: true,
      restrictableModelNames: true,
      rolePermissionRecordRestrictions: true,
      permission: {
        description: true
      }
    }
  },
  methods: {
    removePermissionAction (permissionAction) {
      this.$emit('remove', permissionAction)
      this.$refs.modelForm.close(false)
    }
  }
}
</script>
